import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface LoginStatusState {
	loggedIn: boolean;
	setLoggedIn: (loading: boolean) => void;
}

// When refresh browser, Zustand state stored in memory gets cleared, so need to persist it in local storage.
const useLoginStatusStore = create<LoginStatusState>()(
	persist(
		(set) => ({
			loggedIn: false,
			setLoggedIn: (val: boolean) => set({ loggedIn: val })
		}),
		{
			name: 'loginStatus' // name of item in the local storage (must be unique)
		}
	)
);

export default useLoginStatusStore;
